import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import Item from './item'
import { fetchIncidentDetails, saveIncidentNotes } from '../../actions'

const mapStateToProps = ({ reportIncident }, ownProps) => ({
  id: ownProps.id,
  data: reportIncident.form,
  flags: reportIncident.flags,
  errorMessage: reportIncident.errorMessage,
})

const mapDispatchToProps = (dispatch) => ({
  onFetchIncidentDetails: (incidentId) => {
    dispatch(fetchIncidentDetails(null, {
      queryParams: { id: incidentId },
    }))
  },
  onSaveIncidentNotes: (incidentId, payload) => {
    dispatch(saveIncidentNotes(payload, {
      resourceId: incidentId,
    }))
  },
})

const ItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Item)

const ItemWithParams = (props) => {
  const { id } = useParams()
  return <ItemContainer {...props} id={id} />
}

export default ItemWithParams
